<template>
  <v-card
    :class="[
      'rounded-xl outlined',
      { dimmed: active && !selected?.length, 'highlighted-card': selected?.length },
    ]">
    <v-card-text class="rounded-xl outlined">
      <v-row class="w-100" style="height: 40px">
        <h5 class="v-row d-flex w-100 justify-center align-center" style="height: 30px">
          <span>{{ title }}</span>
          <v-chip v-if="selected.length" label color=" " class="ml-2" x-small
            ><v-icon color="primary" class="mr-1" x-small>mdi-filter </v-icon>
            {{ selected.length }}
            <v-btn icon @click="clearSelection" class="pl-2" style="width: 20px">
              <i class="fas fa-times" style="color: red"></i> </v-btn
          ></v-chip>
        </h5>
      </v-row>
      <div class="w-100 risk-table">
        <!-- Table Rows -->
        <v-row
          no
          v-for="(row, rowIndex) in rows"
          :key="rowIndex"
          :id="'row-' + row"
          class="table-row">
          <div class="header-cell">
            <span class="cell-content">{{ rows[rowIndex] }}</span>
          </div>
          <div
            :id="'cell-' + rowIndex + '-' + colIndex"
            v-for="(col, colIndex) in cols"
            :key="rowIndex + '-' + colIndex"
            :style="{ backgroundColor: getColor(col + row) }"
            :class="[
              'table-cell',
              {
                selected: isSelected(rowIndex, colIndex),
              },
            ]"
            @click="cellClicked(rowIndex, colIndex)">
            <span v-if="data" class="cell-content">
              {{ data[rowIndex][colIndex] }}
            </span>
            <span v-else>0</span>
          </div>
          <div>
            <div class="header-cell">
              <span class="cell-content">{{ getSum(data[rowIndex]) }}</span>
            </div>
          </div>
        </v-row>

        <v-row class="table-row">
          <div class="header-cell"></div>
          <div v-for="(row, rowIndex) in rows" :key="rowIndex" class="header-cell">
            <span class="cell-content">{{ cols[rowIndex] }}</span>
          </div>
          <div class="header-cell"></div>
        </v-row>
      </div>
      <v-row id="legend-wrapper" class="legend-section mt-2">
        <v-col
          cols="6"
          class="d-flex justify-space-between legend-col"
          v-for="rank in ranks"
          :key="rank.name"
          @click="legendClicked(rank.name.toLowerCase())">
          <span class="d-flex align-center">
            <span class="legend" :style="{ 'background-color': rank.color }"> </span>
            <span class="ml-2">{{ rank.name }}</span>
          </span>

          <span class="h5">{{ getRank(rank.name.toLowerCase()) }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    props: ['title', 'data', 'active', 'selectedCells'],
    data() {
      return {
        stopWatch: false,
        dimmed: false,
        cols: ['A', 'B', 'C', 'D', 'E'],
        rows: [5, 4, 3, 2, 1],
        // Ranks with colors
        ranks: [
          { name: 'High', color: '#a50002', count: 0, percentage: 0 },
          { name: 'Medium High', color: '#c44d15', count: 0, percentage: 0 },
          { name: 'Medium', color: '#d2a001', count: 0, percentage: 0 },
          { name: 'Low', color: '#80bd29', count: 0, percentage: 0 },
        ],
        // selected:[],
      };
    },
    computed: {
      selected: {
        get() {
          return this.selectedCells;
        },
        set(value) {
          this.$emit('update:selectedCells', value);
        },
      },
      isDarkModeOn: {
        get() {
          return this.$store.getters['SETTING/GET_DARK_MODE'];
        },
        set(value) {
          this.$store.commit('SET_DARK_MODE', value);
        },
      },
    },
    mounted() {
      const parent = document.getElementById('legend-wrapper');
      const resizeObserver = new ResizeObserver(() => {
        var children = document.getElementsByClassName('legend-section');
        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          if (parent.clientWidth < 350) {
            child.style.fontSize = '9px';
          } else {
            child.style.fontSize = ``;
          }
        }
      });
      resizeObserver.observe(parent);

      // update selected cells from the parent v-model
      if (this.$attrs.value?.length) {
        this.selected = this.$attrs.value;
      }
    },
    methods: {
      select() {
        this.dimmed = false;
      },
      deselect() {
        this.stopWatch = true;
        this.dimmed = true;
        this.selected = [];
        setTimeout(() => {
          this.stopWatch = false;
        });
      },
      clearSelection() {
        this.selected = [];
        this.dimmed = false;
      },
      cellClicked(rowIndex, colIndex) {
        var item = `${this.rows[rowIndex]}${this.cols[colIndex]}`;
        if (this.selected.includes(item)) {
          this.selected = this.selected.filter((i) => i !== item);
        } else {
          this.selected = [...this.selected, item];
        }
      },
      isSelected(rowIndex, colIndex) {
        var item = `${this.rows[rowIndex]}${this.cols[colIndex]}`;
        return this.selected.includes(item);
      },
      getColor(riskScore) {
        switch (riskScore) {
          case 'E5':
          case 'E4':
          case 'E3':
          case 'D5':
            return this.ranks[0].color;
          case 'E2':
          case 'E1':
          case 'D4':
          case 'D3':
          case 'C5':
          case 'C4':
          case 'B5':
          case 'A5':
            return this.ranks[1].color;
          case 'D2':
          case 'D1':
          case 'C3':
          case 'C2':
          case 'C1':
          case 'B4':
          case 'A4':
            return this.ranks[2].color;
          default:
            return this.ranks[3].color;
        }
      },
      getRank(rank) {
        var high = ['E5', 'E4', 'E3', 'D5'];
        var mediumHigh = ['E2', 'E1', 'D4', 'D3', 'C5', 'C4', 'B5', 'A5'];
        var medium = ['D2', 'D1', 'C3', 'C2', 'C1', 'B4', 'A4'];
        var low = ['A3', 'A2', 'A1', 'B3', 'B2', 'B1'];

        var total = this.data.reduce((accumulator, currentArray) => {
          return accumulator + currentArray.reduce((innerAcc, num) => innerAcc + num, 0);
        }, 0);

        switch (rank) {
          case 'high':
            return this.getRankText(high, total);
          case 'medium high':
            return this.getRankText(mediumHigh, total);
          case 'medium':
            return this.getRankText(medium, total);
          case 'low':
            return this.getRankText(low, total);
          default:
            break;
        }
      },
      legendClicked(name) {
        var high = ['5E', '4E', '3E', '5D'];
        var mediumHigh = ['2E', '1E', '4D', '3D', '5C', '4C', '5B', '5A'];
        var medium = ['2D', '1D', '3C', '2C', '1C', '4B', '4A'];
        var low = ['3A', '2A', '1A', '3B', '2B', '1B'];

        this.selected = [];
        switch (name) {
          case 'high':
            this.selected = [...high];
            break;
          case 'medium high':
            this.selected = [...mediumHigh];
            break;
          case 'medium':
            this.selected = [...medium];
            break;
          case 'low':
            this.selected = [...low];
            break;
          default:
            break;
        }
      },
      getRankText(array, total) {
        if (!array) return ``;
        let sum = 0;
        array.forEach((item) => {
          const colLetter = item[0]; // Extract letter part (A-E)
          const rowNumber = parseInt(item[1]); // Extract number part (1-5)

          const colIndex = this.cols.indexOf(colLetter);
          const rowIndex = this.rows.indexOf(rowNumber);

          sum += this.data[rowIndex][colIndex];
        });
        if (total == 0) {
          return `${sum} (0%)`;
        }
        return `${sum} (${Math.round((sum / total) * 100)} %)`;
      },
      getSum(array) {
        const sum = array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        return sum;
      },
    },
    watch: {
      selected() {
        if (!this.stopWatch) {
          this.$emit('input', this.selected);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '~vuetify/src/styles/styles.sass';
  .table-cell:hover {
    filter: brightness(0.7);
  }

  .table-row {
    height: 46px;
    background-color: var(--v-bg2-base);
    justify-content: center;
  }
  .table-row:hover {
    background-color: transparent;
  }
  .table-cell {
    color: map-get($shades, 'white');
    transition: all 0.3s ease;
    margin-right: 2px;
    margin-top: 2px;
    width: 44px;
    height: 44px;
    text-align: center;
    border: 3px solid transparent;
    display: flex;
    flex-wrap: nowrap;
  }

  .header-cell {
    background-color: var(--v-bg2-base);
    transition: all 0.3s ease;
    margin-right: 2px;
    margin-top: 2px;
    width: 44px;
    height: 44px;
    text-align: center;
    display: flex;
    flex-wrap: nowrap;
  }
  .selected {
    filter: brightness(0.7);
    border: solid 3px green;
    // width:20px !important;
    // height:44px !important;
  }
  .legend {
    width: 15px;
    height: 15px;
    display: inline-block;
    background-color: red;
    // text-decoration: underline !important;
    border-radius: 5px;
  }
  .legend-col {
    transition: all 0.3s ease;
  }
  .legend-col:hover {
    text-decoration: underline !important;
    cursor: pointer;
  }
  .dimmed {
    opacity: 0.5;
    //filter: brightness(.9)
    filter: brightness(0.95);
  }
  .highlighted-card {
  }

  #cell-0-0 {
    border-top-left-radius: 5px;
  }
  #cell-0-4 {
    border-top-right-radius: 5px;
  }
  #cell-4-0 {
    border-bottom-left-radius: 5px;
  }
  #cell-4-4 {
    border-bottom-right-radius: 5px;
  }

  .cell-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
